export const loincs_index = ['loincs.index']
export const loincs_create = ['loincs.create']
export const loincs_edit = ['loincs.edit']

export default [].concat(
    loincs_index,
    loincs_create,
    loincs_edit
)
